
import Menu from './help/Menu';
import NotificationsBell from './help/NotificationsBell'

import "./styles.css";

const Layout = ({ children, omniButton, title, badge }) => {

	return (
		<>
			{/* Header */}
			<header className="app-header d-flex justify-content-between align-items-center">
				<h2 className="text-secondary mb-0 px-1">
					{title}
					{badge && (
						<span
							className="badge bg-warning themed-text ms-2"
							style={{ fontSize: "0.6rem" }}
						>
							{badge}
						</span>
					)}
				</h2>

				<NotificationsBell />
			</header>

			{/* Main Content */}
			<main className="app-body styled-scroll">
				<div className="container-fluid">
					{children}
				</div>
			</main>
			
			{omniButton}

			{/* Menu */}
			<Menu />
		</>
	);
};

export default Layout; 